<template>
    <v-container fluid class="ma-0 pa-0">
        <v-row no-gutters>
            <v-col cols="12" class="text-center buttom-border table-head primary--text">
                <v-row no-gutters>
                    <v-col cols="2" class="text-center table-head primary--text">{{kpi.row_header}}</v-col>
                    <v-col cols="2">
                        <kpi-table-header :weeks="weeks1"/>
                    </v-col>
                    <v-col cols="2">
                        <kpi-table-header :weeks="weeks2"/>
                    </v-col>
                    <v-col cols="2">
                        <kpi-table-header :weeks="weeks3"/>
                    </v-col>
                    <v-col cols="2">
                        <kpi-table-header :weeks="weeks4"/>
                    </v-col>
                    <v-col cols="2">
                        <kpi-table-header :weeks="weeks5"/>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12">
                <div class="scrollable">
                    <v-row no-gutters v-for="data in Object.keys(kpis_data)" :key="'row_' + data">                    
                        <template>
                            <v-col cols="12" class="text-center table-head primary--text">
                                <v-row no-gutters>
                                    <v-col cols="2" class="text-center table-head primary--text">
                                        <doc-text-field dense hide-details :value="data" kind="text" readonly :font_weight_black="data=='Total'" :primary_color_text="data=='Total'"></doc-text-field>
                                    </v-col>
                                    <v-col cols="2">
                                        <kpi-table-row :weeks="weeks1" :kpis_data="kpis_data" :data="data"></kpi-table-row>
                                    </v-col>
                                    <v-col cols="2">
                                        <kpi-table-row :weeks="weeks2" :kpis_data="kpis_data" :data="data"></kpi-table-row>
                                    </v-col>
                                    <v-col cols="2">
                                        <kpi-table-row :weeks="weeks3" :kpis_data="kpis_data" :data="data"></kpi-table-row>
                                    </v-col>
                                    <v-col cols="2">
                                        <kpi-table-row :weeks="weeks4" :kpis_data="kpis_data" :data="data"></kpi-table-row>
                                    </v-col>
                                    <v-col cols="2">
                                        <kpi-table-row :weeks="weeks5" :kpis_data="kpis_data" :data="data"></kpi-table-row>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </template>
                    </v-row>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import DocTextField from '../components/DocTextField.vue';
import KpiTableHeader from '../components/KpiTableHeader.vue';
import KpiTableRow from '../components/KpiTableRow.vue';
export default {
    components: {
        DocTextField,
        KpiTableHeader,
        KpiTableRow,
    },
    props: {
        
    },
    computed: { 
        ...mapFields('kpis', [
            'kpi', 
            'kpis_data', 
        ]),
        weeks1() {
            try {
                let keys = Object.keys(Object.keys(this.kpis_data['Total'])).slice(0,3);
                return this.getColsWeeks(keys);
            } catch {
                return {};
            }
        },
        weeks2() {
            try {
                let keys = Object.keys(Object.keys(this.kpis_data['Total'])).slice(3,6);
                return this.getColsWeeks(keys);
            } catch {
                return {};
            }
        },
        weeks3() {
            try {
                let keys = Object.keys(Object.keys(this.kpis_data['Total'])).slice(6,9);
                return this.getColsWeeks(keys);
            } catch {
                return {};
            }
        },
        weeks4() {
            try {
                let keys = Object.keys(Object.keys(this.kpis_data['Total'])).slice(9,12);
                return this.getColsWeeks(keys);
            } catch {
                return {};
            }
        },
        weeks5() {
            try {
                let keys = Object.keys(Object.keys(this.kpis_data['Total'])).slice(12,15);
                return this.getColsWeeks(keys);
            } catch {
                return {};
            }
        }
    },
    methods: {
        getColsWeeks(keys) {
            let lweeks = {};
            for (let i in keys) {
                lweeks[keys[i]] = Object.keys(this.kpis_data['Total'])[keys[i]];
            }
            return lweeks;
        },
    }
};
</script>

<style scoped>
    .table-head{
        border-left-style:solid;
        border-right-style:solid;
        border-bottom-style:solid;
        border-color:#663399;
        border-width: thin;
    }
    .scrollable {
        max-height: 590px;
        overflow: auto;
        -ms-overflow-style: none;
        scrollbar-width: none;
    }
    .scrollable::-webkit-scrollbar {
        display: none;
    }
</style>